import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { fallBackOrder } from '~/src/repositories/cms/constants/cms.constants';
import type { DictionaryInterface } from '~/src/repositories/cms/types/cms.sections.types';
import type {
    CmsReviewsAgentsArticleAttributeInterface,
    ReviewsAgentsInterface,
} from '~/src/repositories/cms/entities/main/types/cms.reviews-agents.types';

export const getMappedReviewsAgentsData = (
    data: DictionaryInterface<CmsReviewsAgentsArticleAttributeInterface>[] | [],
): ReviewsAgentsInterface[] => {
    return (data?.[0]?.articles || [])
        .reduce<ReviewsAgentsInterface[]>((reviews, elem) => {
            if (elem?.status === CmsArticleStatusesEnum.PUBLISHED) {
                const contentAttributes = elem.attributeCategories.otzyvy_nashikh_agentov?.attributes;

                reviews.push({
                    id: elem.id,
                    photo: contentAttributes?.foto?.value || null,
                    name: contentAttributes?.fio?.value || null,
                    jobTitle: contentAttributes?.job_title?.value || null,
                    organizationName: contentAttributes?.organization_name?.value || null,
                    reviewShort: contentAttributes?.review_short?.value || null,
                    content: elem?.content || null,
                    order: elem?.order || fallBackOrder,
                    sefUrl: elem?.sefUrl || null,
                });
            }

            return reviews;
        }, [])
        .sort((item, elem) => (item?.order || fallBackOrder) - (elem?.order || fallBackOrder));
};
